<template>
  <div class="contents" v-loading="loading">
    <div class="title flexB">
      <h2>단어 퀴즈 관리</h2>
    </div>

    <ul class="categories flexL box" v-if="categories.length > 0">
      <li
        :class="{ unselect: true, active: category === '' }"
        @click="handleCategory('')"
      >
        전체 ({{ categoryTotal }})
      </li>
      <li
        :class="{ unselect: true, active: cat.name === category }"
        @click="handleCategory(cat.name)"
        v-for="(cat, i) in categories"
        :key="i"
      >
        {{ getCategoryDisplayName(cat) }} ({{ cat.count }})
      </li>
    </ul>
    <div class="box one">
      <div class="flexB mb20">
        <div class="flex searchWrap">
          <input
            type="text"
            v-model="searchWord"
            placeholder="Search"
            @keyup.enter="search"
          />

          <button @click="search" class="searchIcon">
            <img src="@/assets/images/icon_svg/search.svg" alt="search" />
          </button>
          <button class="cancel line" @click="reset">Cancel</button>
        </div>

        <div class="flex bulkWrap">
          <div class="filebox">
            <label for="fileUploadBlank" class="basic w100 unselect"
              >대량등록(빈칸)</label
            >
            <input
              id="fileUploadBlank"
              type="file"
              @change="handleFileUploadBlank"
              accept=".xlsx, .xls"
            />
          </div>
          <div class="filebox">
            <label for="fileUploadQuestion" class="basic w100 unselect"
              >대량등록(문제)</label
            >
            <input
              id="fileUploadQuestion"
              type="file"
              @change="handleFileUploadQuestion"
              accept=".xlsx, .xls"
            />
          </div>
          <a
            class="line2 sample-link"
            :href="sentenceBulkSampleZipHref"
            download="sentence-bulk-sample-2types.zip"
            >양식 다운로드(2종)</a
          >
          <button
            class="line2 sample-link"
            type="button"
            @click="downloadSentenceData"
          >
            데이터 다운로드
          </button>
          <router-link
            class="line2"
            :to="
              category
                ? { path: '/admin/sentence/register', query: { category } }
                : '/admin/sentence/register'
            "
            >단어 퀴즈 등록</router-link
          >
        </div>
      </div>
      <table>
        <colgroup>
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 7%" />
          <col style="width: 22%" />
          <col style="width: 10%" />
          <col style="width: 29%" />
          <col style="width: 16%" />
        </colgroup>
        <tr>
          <th>
            <el-checkbox
              v-model="checkAll"
              @change="handleCheckAllChange"
            ></el-checkbox>
            <button
              @click="deleteSentences"
              class="delete"
              v-if="ids.length > 0"
            >
              삭제
            </button>
          </th>
          <th>번호</th>
          <th>타입</th>
          <th>카테고리</th>
          <th>단어</th>
          <th>단어 퀴즈</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in sentenceList" :key="i">
          <td>
            <el-checkbox
              v-model="ids"
              :label="data._id"
              class="no-label-checkbox"
              @change="handleIdsChange"
            ></el-checkbox>
          </td>
          <td>{{ total - ((currentPage - 1) * 20 + i) }}</td>
          <td>{{ data.type == 0 || data.type == null ? "빈칸" : "문제" }}</td>
          <td>{{ data.category }}</td>
          <td>
            <router-link to @click.native="handleMove(data._id)">{{
              data.word
            }}</router-link>
          </td>
          <td>
            {{ data.phrase_front
            }}<span style="color: #fe316d">{{ data.word }}</span
            >{{ data.phrase_back }}
          </td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <div class="pagination" v-if="sentenceList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="20"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <NoData v-else />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import moment from "moment";
import {
  fetchSentenceList,
  fetchSentenceCategories,
  createSentenceBulk,
  removeSentenceAll,
} from "@/api/admin";
import { format } from "@/mixins/format";
import NoData from "@/components/contents/Nodata";
import category from "@/config/sentenceCategory.json";
import {
  getSentenceCategoryDisplayName,
  getSentenceCategoryLevelNumber,
} from "@/utils/sentenceCategoryDisplay";

const SENTENCE_BLANK_HEADERS = [
  "카테고리",
  "phrase_front(앞문장)",
  "phrase_back(뒷문장)",
  "word(단어)",
  "보기1",
  "보기2",
  "보기3",
  "comment_en(영어해설)",
  "comment_jp(일본어해설)",
];

const SENTENCE_QUESTION_HEADERS = [
  "카테고리",
  "question(문제)",
  "word(단어)",
  "보기1",
  "보기2",
  "보기3",
  "comment_en(영어해설)",
  "comment_jp(일본어해설)",
];

export default {
  mixins: [format],
  components: { NoData },
  name: "sentenceManage",
  data() {
    return {
      moment: moment,
      loading: false,
      inputMode: "word",
      searchWord: "",
      sentenceList: [],
      total: 0,
      currentPage: 1,
      isNodata: false,
      category: "",
      categories: [],
      categoryTotal: 0,
      isUpload: false,
      ids: [],
      checkAll: false,
    };
  },
  computed: {
    sentenceBulkSampleZipHref() {
      const base = process.env.BASE_URL || "/";
      return `${base.replace(/\/?$/, "/")}sentence-bulk-sample-2types.zip`;
    },
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "3");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === "sentenceRegister" && from.query.page) {
        vm.currentPage = parseInt(from.query.page);
      } else if (to.query.page) {
        vm.currentPage = parseInt(to.query.page);
      } else {
        vm.currentPage = 1;
      }

      if (from.name === "sentenceRegister" && from.query.category) {
        vm.category = from.query.category;
      } else if (to.query.category) {
        vm.category = to.query.category;
      } else {
        vm.category = "";
      }

      const currentQueryPage = to.query.page;
      const currentQueryCategory = to.query.category;
      const newPage = String(vm.currentPage);
      const newCategory = vm.category;

      const shouldReplace =
        currentQueryPage !== newPage ||
        (currentQueryCategory || "") !== newCategory;

      if (shouldReplace) {
        const query = { page: newPage };
        if (newCategory) query.category = newCategory;

        vm.$router.replace({
          name: "sentenceManage",
          query,
        });
      }

      vm.getSentenceList();
    });
  },
  mounted() {
    this.loading = true;
    this.getCategories();
  },
  methods: {
    getCategoryDisplayName(cat) {
      return getSentenceCategoryDisplayName(cat.name);
    },
    deleteSentences() {
      let result = confirm("삭제 하시겠습니까?");
      if (!result) {
        return;
      }
      let data = {
        ids: this.ids,
      };
      removeSentenceAll(data).then((res) => {
        if (res.data.status == 200) {
          alert("삭제 되었습니다.");
          this.reset();
          this.checkAll = false;
          this.ids = [];
        }
      });
    },
    handleCheckAllChange(val) {
      this.ids = val ? this.sentenceList.map((item) => item._id) : [];
    },
    handleIdsChange() {
      this.checkAll = this.ids.length == this.sentenceList.length;
    },
    validateBulkRowBase(row, rowIndex, { wordIndex, exampleStartIndex }) {
      const category = (row[0] ?? "").toString().trim();
      const word = (row[wordIndex] ?? "").toString().trim();
      const examples = [
        row[exampleStartIndex],
        row[exampleStartIndex + 1],
        row[exampleStartIndex + 2],
      ].map((item) => (item ?? "").toString().trim());

      if (!category) {
        return `${rowIndex}행: 카테고리를 입력해 주세요.`;
      }
      if (!word) {
        return `${rowIndex}행: 단어를 입력해 주세요.`;
      }
      if (examples.some((item) => !item)) {
        return `${rowIndex}행: 보기를 3개 모두 입력해 주세요.`;
      }
      if (new Set(examples).size !== examples.length) {
        return `${rowIndex}행: 보기 3개는 서로 중복되면 안 됩니다.`;
      }
      if (!examples.includes(word)) {
        return `${rowIndex}행: 단어와 보기 중 하나가 일치해야 합니다.`;
      }

      return "";
    },
    uploadSentenceBulk(event, type) {
      const file = event.target.files[0];
      if (!file) return;

      this.isUpload = true;

      const reader = new FileReader();
      reader.onload = (e) => {
        const excel = new Uint8Array(e.target.result);
        const workbook = XLSX.read(excel, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // 첫 행(헤더) 제외
        const dataRows = rows
          .slice(1)
          .filter((row) =>
            Array.isArray(row)
              ? row.some((cell) => String(cell ?? "").trim() !== "")
              : false
          );

        if (dataRows.length === 0) {
          this.isUpload = false;
          return alert("업로드할 데이터가 없습니다.");
        }

        const sentences = [];
        for (let i = 0; i < dataRows.length; i += 1) {
          const row = dataRows[i];
          const rowIndex = i + 2;
          const wordIndex = type === 0 ? 3 : 2;
          const exampleStartIndex = type === 0 ? 4 : 3;
          const baseError = this.validateBulkRowBase(row, rowIndex, {
            wordIndex,
            exampleStartIndex,
          });
          if (baseError) {
            this.isUpload = false;
            return alert(baseError);
          }

          const comment_en = (row[type === 0 ? 7 : 6] ?? "").toString().trim();
          const comment_jp = (row[type === 0 ? 8 : 7] ?? "").toString().trim();
          const examples = [
            row[exampleStartIndex],
            row[exampleStartIndex + 1],
            row[exampleStartIndex + 2],
          ].map((item) => (item ?? "").toString().trim());
          const word = (row[wordIndex] ?? "").toString().trim();
          const common = {
            type,
            category: (row[0] ?? "").toString().trim(),
            word,
            comment_en,
            comment_jp,
            examples,
          };

          if (type === 0) {
            const phrase_front = (row[1] ?? "").toString();
            const phrase_back = (row[2] ?? "").toString();
            if (!phrase_front.trim() && !phrase_back.trim()) {
              this.isUpload = false;
              return alert(
                `${rowIndex}행: 앞문장 또는 뒷문장 중 하나 이상 필요합니다.`
              );
            }

            sentences.push({
              ...common,
              phrase_front,
              phrase_back,
            });
          } else {
            const question = (row[1] ?? "").toString().trim();
            if (!question) {
              this.isUpload = false;
              return alert(`${rowIndex}행: 문제를 입력해 주세요.`);
            }

            sentences.push({
              ...common,
              question,
            });
          }
        }

        console.log("sentences", sentences);
        let data = {
          sentences: sentences,
        };
        createSentenceBulk(data).then((res) => {
          if (res.data.status == 200) {
            alert("단어 퀴즈 등록이 완료 되었습니다.");
            this.isUpload = false;
            this.reset();
          } else {
            let message = res.data.message;
            alert(message);
            this.isUpload = false;
          }
        });
      };
      reader.readAsArrayBuffer(file);
    },
    isBlankSentenceType(sentence = {}) {
      return sentence.type == 0 || sentence.type == null;
    },
    buildSentenceBlankExportRow(sentence = {}) {
      const examples = Array.isArray(sentence.examples)
        ? sentence.examples
        : [];

      return [
        sentence.category ?? "",
        sentence.phrase_front ?? "",
        sentence.phrase_back ?? "",
        sentence.word ?? "",
        examples[0] ?? "",
        examples[1] ?? "",
        examples[2] ?? "",
        sentence.comment_en ?? "",
        sentence.comment_jp ?? "",
      ];
    },
    buildSentenceQuestionExportRow(sentence = {}) {
      const examples = Array.isArray(sentence.examples)
        ? sentence.examples
        : [];

      return [
        sentence.category ?? "",
        sentence.question ?? "",
        sentence.word ?? "",
        examples[0] ?? "",
        examples[1] ?? "",
        examples[2] ?? "",
        sentence.comment_en ?? "",
        sentence.comment_jp ?? "",
      ];
    },
    async fetchAllSentencesForExport() {
      const baseParams = {
        searchWord: this.searchWord,
        category: this.category,
      };
      const countRes = await fetchSentenceList({
        ...baseParams,
        page: 1,
        limit: 1,
      });

      if (countRes.data.status !== 200) {
        throw new Error(
          countRes.data.message || "단어 퀴즈 목록을 불러오지 못했습니다."
        );
      }

      const total = Number(countRes.data.total || 0);
      if (total === 0) {
        return [];
      }

      const listRes = await fetchSentenceList({
        ...baseParams,
        page: 1,
        limit: total,
      });

      if (listRes.data.status !== 200) {
        throw new Error(
          listRes.data.message || "단어 퀴즈 목록을 불러오지 못했습니다."
        );
      }

      return listRes.data.data || [];
    },
    writeSentenceWorkbook({ headers, rows, sheetName, filename }) {
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      XLSX.writeFile(workbook, filename);
    },
    async downloadSentenceData() {
      this.loading = true;
      try {
        const sentences = await this.fetchAllSentencesForExport();
        if (sentences.length === 0) {
          return alert("다운로드할 데이터가 없습니다.");
        }

        const blankSentences = sentences.filter((item) =>
          this.isBlankSentenceType(item)
        );
        const questionSentences = sentences.filter(
          (item) => !this.isBlankSentenceType(item)
        );

        if (blankSentences.length === 0 && questionSentences.length === 0) {
          return alert("다운로드할 데이터가 없습니다.");
        }

        const categoryLabel = this.category || "전체";
        const dateLabel = moment().format("YYYYMMDD_HHmmss");
        const downloads = [];

        if (blankSentences.length > 0) {
          downloads.push({
            headers: SENTENCE_BLANK_HEADERS,
            rows: blankSentences.map((item) =>
              this.buildSentenceBlankExportRow(item)
            ),
            sheetName: "빈칸형",
            filename: `sentence-data_blank_${categoryLabel}_${dateLabel}.xlsx`,
          });
        }

        if (questionSentences.length > 0) {
          downloads.push({
            headers: SENTENCE_QUESTION_HEADERS,
            rows: questionSentences.map((item) =>
              this.buildSentenceQuestionExportRow(item)
            ),
            sheetName: "문제형",
            filename: `sentence-data_question_${categoryLabel}_${dateLabel}.xlsx`,
          });
        }

        downloads.forEach((item, index) => {
          setTimeout(() => {
            this.writeSentenceWorkbook(item);
          }, index * 200);
        });
      } catch (err) {
        alert(err.message || "데이터 다운로드에 실패했습니다.");
      } finally {
        this.loading = false;
      }
    },
    handleFileUploadBlank(event) {
      this.uploadSentenceBulk(event, 0);
    },
    handleFileUploadQuestion(event) {
      this.uploadSentenceBulk(event, 1);
    },
    getCategories() {
      fetchSentenceCategories().then((res) => {
        if (res.data.status == 200) {
          this.categoryTotal = res.data.totalCount;
          let categoryCounts = res.data.data;
          const seen = new Set();
          const tempCat = category.categories.filter((name) => {
            if (seen.has(name)) {
              return false;
            }
            seen.add(name);
            return true;
          });

          this.categories = tempCat
            .map((name) => {
              const found = categoryCounts.find((c) => c._id === name);
              return {
                name,
                count: found ? found.count : 0,
                levelNumber: getSentenceCategoryLevelNumber(name),
              };
            })
            .sort((a, b) =>
              this.getCategoryDisplayName(a).localeCompare(
                this.getCategoryDisplayName(b),
                "ko",
                { numeric: true }
              )
            );
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
    handleCategory(cat) {
      this.loading = true;
      this.currentPage = 1;
      this.category = cat;
      let query = {
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "sentenceManage",
        query: query,
      });

      this.getSentenceList();
    },
    customFormatter(date) {
      return moment(date).format("YYYY년 MM월 DD일");
    },
    handleMove(id) {
      let query = {
        id: id,
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "sentenceRegister",
        query: query,
      });
    },

    reset() {
      // this.inputMode = "";
      this.searchWord = "";
      this.sentenceList = [];
      this.total = 0;
      this.currentPage = 1;
      this.category = "";
      this.handleCurrentChange(1);
    },
    search() {
      if (this.searchWord == "") {
        return alert("검색어를 입력해 주세요.");
      }
      this.getSentenceList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let query = {
        page: this.currentPage,
      };
      if (this.category) {
        query.category = this.category;
      }
      this.$router.push({
        name: "sentenceManage",
        query: query,
      });
      this.getSentenceList();
    },
    getSentenceList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        category: this.category,
      };
      fetchSentenceList(params).then((res) => {
        console.log("fetchSentenceList", res);
        if (res.data.status == 200) {
          this.sentenceList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
          this.loading = false;
        } else {
          let message = res.data.message;
          alert(message);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.bulkWrap {
  gap: 10px;
  align-items: center;
}
.bulkWrap .filebox label {
  width: auto !important;
  padding: 0 12px;
  box-sizing: border-box;
}
.bulkWrap .filebox input[type="file"] {
  display: none;
}
.sampleBtn {
  width: auto !important;
  // min-width: 122px;
  padding: 0 12px;
}
::v-deep .no-label-checkbox span {
  vertical-align: middle;
  line-height: 40px;
}

::v-deep .no-label-checkbox .el-checkbox__label {
  display: none;
}
button.delete {
  width: unset;
  height: unset;
  background: unset;
  border: none;
  font-size: 12px;
  margin-bottom: 4px;
  color: #9aa7c1;
}
a.line2.sample-link,
button.line2.sample-link {
  width: auto;
  padding: 0 12px !important;
  box-sizing: border-box;
  cursor: pointer;
  font-weight: 400;
}
.line2 {
  margin-left: 0 !important;
}
</style>
